import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "star"
const StarIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path
            fillRule="evenodd"
            d="M11.328 2.863C11.603 2.306 12.398 2.306 12.672 2.863L15.306 8.2 21.195 9.055C21.81 9.145 22.055 9.901 21.61 10.335L17.349 14.488 18.356 20.354C18.454 20.928 17.895 21.374 17.372 21.19L17.267 21.144 12 18.374 6.732 21.145 6.628 21.19C6.105 21.375 5.546 20.928 5.644 20.354L6.65 14.488 2.39 10.335C1.943 9.9 2.19 9.145 2.803 9.055L8.694 8.2zM9.69 9.571 4.524 10.321 8.262 13.965 7.378 19.109 12 16.68 16.62 19.11 15.739 13.964 19.475 10.32 14.31 9.571 12 4.889z"
            clipRule="evenodd"
          />
        </svg>
      }
    </span>
  )
}
export default StarIcon
